import { render, staticRenderFns } from "./CardSmallProgress.vue?vue&type=template&id=6ec0f086&scoped=true&"
import script from "./CardSmallProgress.vue?vue&type=script&lang=js&"
export * from "./CardSmallProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0f086",
  null
  
)

export default component.exports